import React, { useState, useEffect } from 'react';
import '../styles/SectionHelp.css';
import helpData from '../data/sectionHelp.json';

const SectionHelp = ({ sectionId, isMobile }) => {
  const [showBasic, setShowBasic] = useState(!isMobile);
  const [showDetailed, setShowDetailed] = useState(false);
  const [helpContent, setHelpContent] = useState(null);

  useEffect(() => {
    // Reset states when section changes
    setShowBasic(!isMobile);
    setShowDetailed(false);
    
    // Get help content for this section
    if (sectionId && helpData[sectionId]) {
      setHelpContent(helpData[sectionId]);
    } else {
      setHelpContent(null);
    }
  }, [sectionId, isMobile]);

  if (!helpContent) return null;

  const toggleInfo = () => {
    setShowBasic(!showBasic);
    if (showDetailed && !showBasic) {
      setShowDetailed(false);
    }
  };

  const toggleDetailed = () => {
    setShowDetailed(!showDetailed);
  };

  const openVideo = () => {
    if (helpContent.videoUrl) {
      window.open(helpContent.videoUrl, '_blank');
    }
  };

  return (
    <div className="section-help">
      {isMobile ? (
        // Mobile view
        <div className="section-help-mobile">
          <button 
            className="info-button"
            onClick={toggleInfo}
            aria-expanded={showBasic}
          >
            Instructions
          </button>
          
          {showBasic && (
            <div className="help-content-container">
              <p className="help-text">{helpContent.basic}</p>
              
              {helpContent.detailed && (
                <div className="help-buttons">
                  <button 
                    className="more-button"
                    onClick={toggleDetailed}
                    aria-expanded={showDetailed}
                  >
                    {showDetailed ? 'Less' : 'More Instructions'}
                  </button>
                  
                  {helpContent.videoUrl && (
                    <button 
                      className="video-button"
                      onClick={openVideo}
                    >
                      Video
                    </button>
                  )}
                </div>
              )}
              
              {showDetailed && (
                <div className="detailed-help">
                  {helpContent.detailed.split('\n').map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        // Desktop view
        <div className="section-help-desktop">
          {showBasic && (
            <div className="help-content-container">
              <p className="help-text">{helpContent.basic}</p>
              
              {helpContent.detailed && (
                <div className="help-buttons">
                  <button 
                    className="more-button"
                    onClick={toggleDetailed}
                    aria-expanded={showDetailed}
                  >
                    {showDetailed ? 'Less' : 'More Instructions'}
                  </button>
                  
                  {helpContent.videoUrl && (
                    <button 
                      className="video-button"
                      onClick={openVideo}
                    >
                      Video
                    </button>
                  )}
                </div>
              )}
              
              {showDetailed && (
                <div className="detailed-help">
                  {helpContent.detailed.split('\n').map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SectionHelp;
